export var NAMESPACE = 'APEX_ONLINE_MENU_LEGACY_URL';

export var URL = function URL(apiUrl) {
  return apiUrl + '/legit/api/v1/legacyURL';
};

// Trigger a fetch request in sagas
export var LEGACY_URL_REQUEST = NAMESPACE + '/REQUEST';
export var LEGACY_URL_SUCCESS = NAMESPACE + '/SUCCESS';
export var LEGACY_URL_ERROR = NAMESPACE + '/ERROR';
export var LEGACY_URL_NOT_ASKED = NAMESPACE + '/NOT_ASKED';
export var LEGACY_URL_LOADING = NAMESPACE + '/LOADING';